var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell-wrapper"},[_c('a',{staticClass:"cell",attrs:{"href":_vm.$router.resolve(_vm.route).href,"ontouchstart":""}},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('h6',[_vm._v(_vm._s(_vm.subtitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }